export default __webpack_public_path__ + "static/media/ProfileImg.2c05bed9.jpg";